import { Link } from 'react-router-dom';
import { categories, siteInfo, hotTags } from '@/mocks/videos';

export default function Footer() {
  return (
    <footer className="bg-background-900 text-foreground-200">
      <div className="w-full px-4 md:px-6">
        {/* Main Footer */}
        <div className="py-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="text-2xl font-bold text-background-50 font-heading whitespace-nowrap cursor-pointer">
              {siteInfo.logo}
            </Link>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              51黑料是最全面的吃瓜视频与黑料视频聚合平台，每日更新海量视频内容，覆盖娱乐圈、网红圈、直播圈等多领域，为你带来最精彩的黑料内容。
            </p>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="抖音">
                <i className="ri-tiktok-line"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-300 hover:text-background-50 hover:bg-primary-500 transition-all duration-200 cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line"></i>
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link></li>
              <li><Link to="/category/chigua" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">吃瓜视频</Link></li>
              <li><Link to="/category/heiliaovideo" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">黑料视频</Link></li>
              <li><Link to="/category/zhibo" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">直播</Link></li>
              <li><Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
              视频分类
            </h4>
            <ul className="space-y-2.5">
              {categories.slice(1).map((cat) => (
                <li key={cat.id}>
                  <Link
                    to={`/category/${cat.slug}`}
                    className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                  >
                    {cat.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Hot Tags */}
          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4 tracking-wide">
              热门标签
            </h4>
            <div className="flex flex-wrap gap-2">
              {hotTags.slice(0, 8).map((tag) => (
                <span
                  key={tag.name}
                  className="px-3 py-1 text-xs rounded-md bg-background-800 text-foreground-400 whitespace-nowrap cursor-pointer hover:bg-primary-500 hover:text-background-50 transition-all duration-200"
                >
                  {tag.name}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-5 border-t border-background-700/50 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} {siteInfo.name}. 版权所有.
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">服务条款</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-background-50 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}